import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

interface Props {
  /**
   * When true, clicking "Go Back" navigates straight to /dashboard with no
   * confirmation prompt. Use on terminal screens (e.g. the success state)
   * where there's no in-progress work to abandon.
   */
  skipConfirm?: boolean;
}

const SDAGoBack: React.FC<Props> = ({ skipConfirm = false }) => {
  const navigate = useNavigate();
  const [showConfirm, setShowConfirm] = useState(false);

  const handleClick = () => {
    if (skipConfirm) {
      navigate("/dashboard");
      return;
    }
    setShowConfirm(true);
  };

  return (
    <>
      <button
        type="button"
        className="mb-6 inline-flex items-center gap-1 text-sm font-medium text-muted transition-colors hover:text-primary"
        onClick={handleClick}
      >
        &larr; Go Back
      </button>

      {showConfirm && (
        <div
          role="dialog"
          aria-modal="true"
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4"
        >
          <div className="w-full max-w-md rounded-2xl bg-white shadow-xl">
            <div className="border-b border-gray-100 px-6 py-4">
              <h3 className="text-base font-semibold text-primary">
                Leave this flow?
              </h3>
            </div>
            <div className="px-6 py-5">
              <p className="text-sm text-gray-700">
                Your progress will not be saved. You'll need to start over the
                next time you come back.
              </p>
            </div>
            <div className="flex justify-end gap-3 border-t border-gray-100 px-6 py-4">
              <button
                type="button"
                className="rounded-lg px-4 py-2 text-sm font-medium text-gray-600 transition-colors hover:bg-gray-100"
                onClick={() => setShowConfirm(false)}
              >
                Continue
              </button>
              <button
                type="button"
                className="rounded-lg bg-danger px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-red-600"
                onClick={() => navigate("/dashboard")}
              >
                Leave
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SDAGoBack;
